import { useEffect } from 'react';

export type TpEventTypeFilter = string | null;

export interface TpEventListener {
  (type: string, payload: any): void;
}

let evListenerCounter = 0;
const activeEventListeners: { [id: string]: { eventTypeFilter: TpEventTypeFilter; callBack: TpEventListener } } = {};

export function sendEvent(eventType: string, payload: any) {
  for (const key in activeEventListeners) {
    const listener = activeEventListeners[key];
    if (!listener.eventTypeFilter || listener.eventTypeFilter == eventType) listener.callBack(eventType, payload);
  }
}

function registerEventlistener(eventTypeFilter: TpEventTypeFilter, callBack: any): string {
  evListenerCounter += 1;
  const listenerId = `EVLST_${evListenerCounter}`;
  activeEventListeners[listenerId] = {
    eventTypeFilter,
    callBack,
  };
  return listenerId;
}

function unRegisterEventlistener(listenerId: string): void {
  if (activeEventListeners[listenerId]) delete activeEventListeners[listenerId];
}

export function useEventNotification(
  eventTypeFilter: TpEventTypeFilter,
  callBack: TpEventListener,
  dependencies: any[],
) {
  useEffect(() => {
    const listenerId = registerEventlistener(eventTypeFilter, callBack);
    //function called on quit
    return () => {
      if (listenerId) {
        if (listenerId) unRegisterEventlistener(listenerId);
      }
    };
  }, dependencies);
}
